import { TrendingDown } from "lucide-react";

/**
 * PriceBlock — shows MRP strikethrough + Tablo price + savings pill.
 *
 * Props:
 *  - listPrice (number): the restaurant's MRP in INR
 *  - tabloPrice (number): the Tablo-locked price in INR
 *  - suffix (string): "/head" or similar
 *  - size: "sm" | "md" | "lg"
 *  - align: "right" | "left"
 */
export default function PriceBlock({ listPrice, tabloPrice, suffix = "", size = "md", align = "right", testid }) {
  const hasDiscount = listPrice && listPrice > tabloPrice;
  const pct = hasDiscount ? Math.round(((listPrice - tabloPrice) / listPrice) * 100) : 0;

  const sizeMap = {
    sm: { main: "text-base", muted: "text-[11px]", pill: "text-[10px]" },
    md: { main: "font-serif text-xl", muted: "text-xs", pill: "text-[10px]" },
    lg: { main: "font-serif text-2xl", muted: "text-sm", pill: "text-[11px]" },
  };
  const s = sizeMap[size] || sizeMap.md;
  const alignCls = align === "left" ? "items-start text-left" : "items-end text-right";

  return (
    <div className={`flex flex-col ${alignCls}`} data-testid={testid}>
      {hasDiscount && (
        <span className={`${s.muted} text-light-ink/70 line-through leading-3`}>
          ₹{listPrice.toLocaleString("en-IN")}{suffix}
        </span>
      )}
      <span className={`${s.main} text-ink leading-tight mt-0.5`}>
        ₹{tabloPrice.toLocaleString("en-IN")}
        {suffix && <span className="text-sm text-light-ink font-sans font-normal">{suffix}</span>}
      </span>
      {hasDiscount && (
        <span className={`${s.pill} inline-flex items-center gap-0.5 mt-1 px-1.5 py-0.5 rounded-full bg-amber/15 text-amber font-medium uppercase tracking-wider`}>
          <TrendingDown className="w-2.5 h-2.5" strokeWidth={2}/>
          Tablo · {pct}% off
        </span>
      )}
    </div>
  );
}
